/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsHoopListItem
 */
export interface ControlcenterMelcoModelsHoopListItem {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    english_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    metric_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    version?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    width_points?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    height_points?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    presser_foot?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    enable_templates?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    backward_compatibility_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    supplier_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    supplier_product_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    supplier_product_name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    discontinued?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    published_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsHoopListItem
     */
    signature?: string | null;
}

export function ControlcenterMelcoModelsHoopListItemFromJSON(json: any): ControlcenterMelcoModelsHoopListItem {
    return ControlcenterMelcoModelsHoopListItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsHoopListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsHoopListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'english_name': !exists(json, 'english_name') ? undefined : json['english_name'],
        'metric_name': !exists(json, 'metric_name') ? undefined : json['metric_name'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'width_points': !exists(json, 'width_points') ? undefined : json['width_points'],
        'height_points': !exists(json, 'height_points') ? undefined : json['height_points'],
        'presser_foot': !exists(json, 'presser_foot') ? undefined : json['presser_foot'],
        'enable_templates': !exists(json, 'enable_templates') ? undefined : json['enable_templates'],
        'backward_compatibility_id': !exists(json, 'backward_compatibility_id') ? undefined : json['backward_compatibility_id'],
        'supplier_id': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'supplier_name': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'supplier_product_id': !exists(json, 'supplier_product_id') ? undefined : json['supplier_product_id'],
        'supplier_product_name': !exists(json, 'supplier_product_name') ? undefined : json['supplier_product_name'],
        'discontinued': !exists(json, 'discontinued') ? undefined : json['discontinued'],
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'published_date': !exists(json, 'published_date') ? undefined : (json['published_date'] === null ? null : new Date(json['published_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
    };
}

export function ControlcenterMelcoModelsHoopListItemToJSON(value?: ControlcenterMelcoModelsHoopListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'english_name': value.english_name,
        'metric_name': value.metric_name,
        'version': value.version,
        'width_points': value.width_points,
        'height_points': value.height_points,
        'presser_foot': value.presser_foot,
        'enable_templates': value.enable_templates,
        'backward_compatibility_id': value.backward_compatibility_id,
        'supplier_id': value.supplier_id,
        'supplier_name': value.supplier_name,
        'supplier_product_id': value.supplier_product_id,
        'supplier_product_name': value.supplier_product_name,
        'discontinued': value.discontinued,
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'published_date': value.published_date === undefined ? undefined : (value.published_date === null ? null : value.published_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'signature': value.signature,
    };
}


